module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_decollte_white-da498b62c4cef32f1f64fb20986504d5.svg";